import React, { useEffect,  } from "react";
import { useDispatch, useSelector } from "react-redux";
import { RootStateType } from "../../store/RootState";
import { ThunkDispatch } from "redux-thunk";
import { clearThreedHtml } from "../../store/slices/paymentGatewaySlice";
import InnerHTML from 'dangerously-set-html-content'


const PaymentThreedGate = () => {

    const { threedHtml } = useSelector((state: RootStateType) => state.paymentGateway);

    const dispatch = useDispatch<ThunkDispatch<any, any, any>>();

 
 
    const onloadIframe = (event: any) => {

 
    }

    useEffect(() => {
        if (threedHtml && threedHtml.length>0) {
            setTimeout(() => {
                dispatch(clearThreedHtml());
            }, 2000);
        }

       
    }, [threedHtml]);

    const callScript=
    `
   <script>
    try {
        const href =   location.href;
        window.parent.postMessage(href, '*')
      } catch (error) {
          alert(error);
      }

      </script>
    `;

    return(
        <InnerHTML html={threedHtml + callScript}  allowRerender 
        onLoad={onloadIframe}
        />
    ); 
}
export default PaymentThreedGate;